import React from 'react'

import { MintButton } from '../../styles/PageLayout'

const BtnMintOne = ({ className, ...props }) => (
  <MintButton
    width="43"
    height="45"
    viewBox="0 0 43 45"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <rect x="0.5" y="0.5" width="42" height="44" fill="white" stroke="#591ED8" />
    <path
      d="M16.7969 11.8881V21.8287H17.9167V16.8584H20.1562V15.6158H17.9167V9.40332H16.7969V11.8881Z"
      fill="#591ED8"
    />
    <path
      d="M20.1562 19.3435V21.8287H28.5547V9.40332H27.3552V20.5861H24.9556V9.40332H23.7557V15.6158H21.3561V16.8584H23.7557V20.5861H21.3561V16.8584H20.1562V19.3435Z"
      fill="#591ED8"
    />
    <path d="M17.8047 21.8281V23.1716H18.9805V24.5147H20.1562V21.8281H17.8047Z" fill="#591ED8" />
    <path d="M21.388 25.5221H23.8516V24.5146H20.1562V25.5221H21.388Z" fill="#591ED8" />
    <path d="M27.5469 9.40285V8.05957H25.1953V9.40285H27.5469Z" fill="#591ED8" />
    <path d="M14.4453 24.3712V9.40332H13.1016V26.866H14.4453V24.3712Z" fill="#591ED8" />
    <path d="M15.4531 28.0966V26.8652H14.4453V30.5593H15.4531V28.0966Z" fill="#591ED8" />
    <path d="M25.1281 30.5596H15.4531V31.9029H27.5469V30.5596H25.1281Z" fill="#591ED8" />
    <path d="M27.5469 28.0966V30.5593H28.5547V26.8652H27.5469V28.0966Z" fill="#591ED8" />
    <path d="M28.5547 23.0875V26.8654H29.8984V21.8281H28.5547V23.0875Z" fill="#591ED8" />
    <path d="M16.7969 9.40285V8.05957H14.4453V9.40285H16.7969Z" fill="#591ED8" />
    <path
      d="M27.3792 34.4222V35.6812H15.6208V31.9033H14.4453V36.9406H28.5547V31.9033H27.3792V34.4222Z"
      fill="#591ED8"
    />
  </MintButton>
)

export default BtnMintOne
